export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker.168068b0.gif";